import { Brand, createBranded } from '@deltasierra/type-utilities';
import { BuilderTemplateId } from '../builderTemplate';
import { BuilderDocument, BuilderEmailDocument, BuilderPrintDocument } from '../builderDocument';
import { FullAuditable, HasId } from '../common';
import { LocationId } from '../location';
import { Upload, UploadId } from '../upload';

export type LocationDraftId = Brand<number, 'LocationDraftId'>;
export const LocationDraftId = createBranded<LocationDraftId>();

interface BaseLocationDraft extends HasId<LocationDraftId>, FullAuditable {
    title: string;
    document: BuilderDocument | BuilderEmailDocument | BuilderPrintDocument;
    builderTemplateId: BuilderTemplateId;
    locationId: LocationId;
    compositeImageUploadId: UploadId | null;
}

export interface LocationDraft extends BaseLocationDraft {
    compositeImageUpload: Upload;
}
